module.exports = __webpack_public_path__ + "img/icon_process3.a4119699.png";